import React from 'react';
import {
  Button,
  ButtonGroup,
} from '@blueprintjs/core';
import './ContractsPagination.sass';

function ContractsPagination({ current, last, onPrev, onNext }) {
  return (
    <div className="ContractsPagination">
      <p>{`Seite ${current}/${last}`}</p>
      <ButtonGroup>
        { current > 1 &&
          <Button icon="fast-backward" onClick={onPrev}>Vorherige</Button>
        }
        { current < last &&
          <Button rightIcon="fast-forward" onClick={onNext}>Nächste</Button>
        }
      </ButtonGroup>
    </div>
  );
}

export default ContractsPagination;
